import { createAction, props } from '@ngrx/store';
import { ContractGridItem } from 'src/app/clinical/contracts/grid/models/contract-grid-item.model';
import { PerformanceEval } from 'src/app/clinical/contracts/grid/models/performance-eval.model';

export const loadPerformanceEval = createAction(
    '[CLINICAL] Load Performance Eval',
    props<{
        payload: {
            contract: ContractGridItem;
        };
    }>()
);

export const loadPerformanceEvalSuccess = createAction(
    '[CLINICAL] Load Performance Eval Success',
    props<{
        payload: {
            performanceEval: PerformanceEval;
        };
    }>()
);

export const loadPerformanceEvalFail = createAction(
    '[CLINICAL] Load Performance Eval Fail',
    props<{
        payload: {
            contract: ContractGridItem;
        };
    }>()
);

export const storePerformanceEval = createAction(
    '[CLINICAL] Store Performance Eval',
    props<{
        payload: {
            performanceEval: PerformanceEval;
        };
    }>()
);

export const storePerformanceEvalSuccess = createAction(
    '[CLINICAL] Store Performance Eval Success',
    props<{
        payload: {
            performanceEval: PerformanceEval;
        };
    }>()
);

export const storePerformanceEvalFail = createAction(
    '[CLINICAL] Store Performance Eval Fail',
    props<{
        payload: {
            error: any;
        };
    }>()
);
